



import { Vue, Component, Mixins } from 'vue-property-decorator';
import PagesMixin from '../components/organisms/PagesMixin';

@Component({ components: {} })
export default class TopPage extends Mixins(PagesMixin) {
  mounted() {
    // Top Page は / だが、このページもロードされるためパスが一致してない時だけリダイレクト
    if (location.pathname !== '/') {
      location.href = '/';
    }
  }
}
